import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import type { OryGetInput, OryGetOutput } from '../../model';
import type { OryRetrievableFlow } from '../flow-capabilities';
import { OryKratosBaseFlow } from './base.flow';

/**
 * Retrieves current user session. Retrieve-only flow.
 * 
 * Throws 401 error if no active session exists.
 */
@Injectable({
  providedIn: 'root',
})
export class OrySessionFlow<IdentityTraits extends object = object>
  extends OryKratosBaseFlow
  implements OryRetrievableFlow<'session', IdentityTraits>
{
  get(
    input: OryGetInput<'session'> = {}
  ): Observable<OryGetOutput<'session', IdentityTraits>> {
    return this.fromOryRequest(this.iamApi.toSession(input));
  }
}

